import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { authConfigured, env } from "./env";

/**
 * The SoundLayer ID lives in Supabase Auth. The client is null when the app
 * is not configured; screens render an explicit "not configured" state
 * instead of a demo account.
 */
export const supabase: SupabaseClient | null = authConfigured
  ? createClient(env.supabaseUrl, env.supabaseKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;
